export default __webpack_public_path__ + "static/media/sprecher.74b56831.svg";